<template>
<div v-if="pt395Init.isLogin == true" id="pt395" class="pt395">
    <breadcrumb :decriptPage="$t('common.labels.myPgage')"></breadcrumb>
    <div class="section page-mypage mb32">
        <!--マイページメニュー -->
        <h2 class="itemTitle">{{$t("common.labels.myPgage")}}</h2>
        <div class="myPage">
            <h3 class="myPageMenu">{{$t("common.labels.myPgage")}} {{$t("pt395.labels.menu")}}</h3>
            <p class="welcomeCustome">
                {{$t("pt395.labels.welcome")}}{{pt395Init.customName}}&nbsp;{{$t("common.labels.mr")}}
                <span v-if="pt395Init.idDispFlg == 1" class="customerId">&nbsp; {{$t("pt395.labels.kokyakuId")}}{{ pt395Init.kokyakuCd }}</span>
                <br>
            </p>
            <!--マイページ上段 -->
            <ul class="mypage-nav cf mb32">
                <!--登録情報確認-->
                <li id="pt400" class="mypage-personal" v-if="pt395Init.customerFlg == 1">
                    <router-link :to="generateLinkParams(8,pt395Init.customerPage)">
                        <b class="confirmRegist">{{$t("pt395.labels.confirmRegistInfor")}}</b><br>
                        <span class="mypage-notes">{{$t("pt395.labels.confirmMember[0]")}}<br>{{$t("pt395.labels.confirmMember[1]")}}</span>
                    </router-link>
                </li>
                <!--購入履歴 -->
                <li id="pt430" class="mypage-history" v-if="pt395Init.orderHisFlg == 1">
                    <router-link :to="generateLinkParams(9,pt395Init.orderHisPage)">
                        <b class="purchaseHistory">{{$t("common.labels.purchaseHistory")}}</b><br>
                        <span class="mypage-notes">{{$t("pt395.labels.viewOrderHistory[0]")}}<br>{{$t("pt395.labels.viewOrderHistory[1]")}}</span>
                    </router-link>
                </li>
                <!--代理購入履歴 -->
                <li id="pt620" class="mypage-suborder" v-if="pt395Init.dairiOrderHisFlg == 1 && pt395Init.dairiOrderUserFlg == 1">
                    <router-link :to="generateLinkParams(24,pt395Init.dairiOrderHis)">
                        <b class="dairiPurchaseHistory">{{$t("common.labels.dairiPurchaseHistory")}}</b><br>
                        <span class="mypage-notes">{{$t("pt395.labels.viewDairiOrderHistory[0]")}}<br>{{$t("pt395.labels.viewDairiOrderHistory[1]")}}</span>
                    </router-link>
                </li>
                <!--見積一覧 -->
                <li class="mypage-quotation" v-if="pt395Init.quotationFlg == 1">
                    <router-link :to="generateLinkParams(104,pt395Init.mitumoriPage)">
                        <b class="quotation">{{$t("pt395.labels.quotationList")}}</b><br>
                        <span class="mypage-notes">{{$t("pt395.labels.viewQuotationList[0]")}}<br>{{$t("pt395.labels.viewQuotationList[1]")}}</span>
                    </router-link>
                </li>
                <!--請求一覧 -->
                <li id="pt425" class="mypage-seikyuu" v-if="pt395Init.kokyakuKbn == 'B' && pt395Init.seikyuuFlg == 1">
                    <router-link :to="generateLinkParams(106,pt395Init.seikyuPage)">
                        <b class="invoice">{{$t("pt010.labels.invoiceList")}}</b><br>
                        <span class="mypage-notes">{{$t("pt395.labels.viewInvoiceList[0]")}}<br>{{$t("pt395.labels.viewInvoiceList[1]")}}</span>
                    </router-link>
                </li>
                <!--定期照会 -->
                <li id="tk001" class="mypage-teiki" v-if="pt395Init.teikiFlg == '1'">
                    <router-link :to="generateLinkParams(88,pt395Init.teikiPage)">
                        <b class="teiki">{{$t("tk001.labels.title")}}</b><br> 
                        <span class="mypage-notes">{{$t("pt395.labels.teikiInfo[0]")}}<br>{{$t("pt395.labels.teikiInfo[1]")}}</span>
                    </router-link>
                </li>
                <!--ランク -->
                <li id="pt482" class="mypage-rank" v-if="(pt395Init.kokyakuKbn == 'B' && pt395Init.tokuisakiFlg == 1) || (pt395Init.kokyakuKbn == 'C' && pt395Init.kokyakuFlg == 1)">
                    <router-link :to="generateLinkParams(110,pt395Init.rankPage)">
                        <b class="ranking">{{$t("pt395.labels.rank")}}</b><br> 
                        <span class="mypage-notes">{{$t("pt395.labels.rankInfo[0]")}}<br>{{$t("pt395.labels.rankInfo[1]")}}</span>
                    </router-link>
                </li>
                <!-- 配送先リスト -->
                <li id="pt405" class="mypage-delivery" v-if="pt395Init.tdkListFlg == '1'">
                    <router-link :to="generateLinkParams(77,pt395Init.tdkPage)">
                        <b class="shipping">{{$t("pt395.labels.shippingList")}}</b><br> 
                        <span class="mypage-notes">{{$t("pt395.labels.shipingInfor[0]")}}<br>{{$t("pt395.labels.shipingInfor[1]")}}</span>
                    </router-link>
                </li>
                <!-- 送り主リスト -->
                <li id="pt435" class="mypage-sender" v-if="pt395Init.okuriNushiListFlg == '1'">
                    <router-link :to="generateLinkParams(102,pt395Init.okuriPage)">
                        <b class="sender">{{$t("pt395.labels.shippingList").replace("配送先","送主")}}</b><br> 
                        <span class="mypage-notes">{{$t("pt395.labels.shipingInfor[0]")}}<br>{{$t("pt395.labels.shipingInfor[1]").replace("配送先","送主")}}</span>
                    </router-link>
                </li>
                <!-- お気に入り -->
                <li id="pt440" class="mypage-favorite" v-if="pt395Init.favouriteFlg == '1'">
                    <router-link :to="generateLinkParams(7,pt395Init.okiniPage)">
                        <b class="favorite">{{$t("pt395.labels.favorite")}}</b><br> 
                        <span class="mypage-notes">{{$t("pt395.labels.favoriteInfo")}}</span>
                    </router-link>
                </li>
                <!-- 購入履歴リスト出力 -->
                <li id="pt450" class="mypage-orderHisList" v-if="pt395Init.orderHisOutputOpt == '1'">
                     <router-link :to="generateLinkParams(29,pt395Init.orderHisDlPage)">
                        <b class="orderHisList">{{$t("pt395.labels.orderHisList")}}</b><br> 
                        <span class="mypage-notes">{{$t("pt395.labels.orderHisListInfo")}}</span>
                    </router-link>
                </li>
                <!-- ポイント照会 -->
                <li id="pt480" class="mypage-point" v-if="pt395Init.pointFlg == '1'">
                     <router-link :to="generateLinkParams(17,pt395Init.pointHisPage)">
                        <b class="pointNm">{{$t("pt395.labels.point")}}</b><br> 
                        <span class="mypage-notes">{{$t("pt395.labels.pointInfo[0]")}}<br>{{$t("pt395.labels.pointInfo[1]")}}</span>
                    </router-link>
                </li>
                <!-- クーポン照会 -->
                <li id="pt485" class="mypage-coupon" v-if="pt395Init.couponFlg == '1'">
                     <router-link :to="generateLinkParams(107, pt395Init.couponPage, { modeKbn: 0 })">
                        <b class="coupon">{{$t("pt395.labels.coupon")}}</b><br> 
                        <span class="mypage-notes">{{$t("pt395.labels.couponInfo[0]")}}<br>{{$t("pt395.labels.couponInfo[1]")}}</span>
                    </router-link>
                </li>
                <!-- レビュー一覧 -->
                <li id="pt462" class="mypage-review" v-if="pt395Init.reviewFlg == '1'">
                     <router-link :to="generateLinkParams(84, pt395Init.reviewPage, { processKbn: 0 })">
                        <b class="review">{{$t("pt395.labels.review")}}</b><br> 
                        <span class="mypage-notes">{{$t("pt395.labels.reviewInfo[0]")}}<br>{{$t("pt395.labels.reviewInfo[1]")}}</span>
                    </router-link>
                </li>
                <!-- クレジットカード登録 -->
                <li id="pt402" class="mypage-credit" v-if="pt395Init.creditFlg == '1'">
                     <router-link :to="generateLinkParams(86,pt395Init.cardPage)">
                        <b class="credit">{{$t("pt395.labels.credit")}}</b><br> 
                        <span class="mypage-notes">{{$t("pt395.labels.creditInfo[0]")}}<br>{{$t("pt395.labels.creditInfo[1]")}}</span>
                    </router-link>
                </li>
                <!-- パスワード変更 -->
                <li id="pt403" class="mypage-passWord" v-if="pt395Init.passChangeFlg == '1'">
                     <router-link :to="generateLinkParams(87,pt395Init.passwordPage)">
                        <b class="credit">{{$t("pt395.labels.passWord")}}</b><br> 
                        <span class="mypage-notes">{{$t("pt395.labels.passWordInfo[0]")}}<br>{{$t("pt395.labels.passWordInfo[1]")}}</span>
                    </router-link>
                </li>
                <!-- 会員退会 -->
                <li id="pt420" class="mypage-withdrawal" v-if="pt395Init.memberDelFlg == '1'">
                    <router-link :to="generateLinkParams(11,pt395Init.taikaiPage)">
                        <b class="drawalMember">{{$t("pt395.labels.drawalMember")}}</b><br>
                        <span class="mypage-notes">{{$t("pt395.labels.leaveMember")}}</span>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</div>
</template>
<script>
import common from "assets/js/common";
import axios from "assets/js/request";
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";

export default {
    name: "PT395MemberMyPageParts",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    components:{
        Breadcrumb
    },
    data() {
        return {
            pt395Init:{
                customName: null
            },
           SiteConstants: SiteConstants,
           site: ""
        }
    },
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        if (_this.ptInitData){
            _this.pt395Init = _this.ptInitData;
        }else{
            // eslint-disable-next-line
            axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT395 + _this.$UrlConstants.DO_INIT).then(function(response) {
                _this.pt395Init = response.data;
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
        // 未ログインの場合はログイン画面へ遷移
        if(_this.pt395Init.isLogin == false || _this.pt395Init.isLogin == undefined){
            const parameter = _this.generateLinkParams(18, _this.pt395Init.loginPage, {returnFlg: 1, fromMyPage: 1});
            _this.$router.push(parameter);
        }
    },
    /*
    * メソッド
    */
    methods: {
        // ルーターリンクパラメータ設定
        generateLinkParams(pageNo, customUrl, additionalQuery = {}, additionalParams = {}) {
            return common.routerLinkParams(pageNo, customUrl, additionalQuery, additionalParams);
        }
    }
}
</script>